// add event name. and group event name by feature.
// you need to event name by `import { eventMetaMap } from '../utils/slEventBus';`
// eventMetaMap.promotion.GROUP_NAME.EVENT_NAME
// i.e: feature with service structure
// promotion: { xxxxx }
const eventMetaMap = {
  general: {
    currencyChanged: 'general.currencyChanged',
  },
  cart: {
    miniCartLoadData: 'cart.miniCartLoadData',
    itemAdded: 'cart.itemAdded',
    itemUpdated: 'cart.itemUpdated',
    itemRemoved: 'cart.itemRemoved',
  },
  pdp: {
    quantityChanged: 'pdp.quantityChanged',
    variationChanged: 'pdp.variationChanged',
    addonQuantityChanged: 'pdp.addonQuantityChanged',
  },
};

export default eventMetaMap;
